import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, getToken } from "@/lib/api";
import { ClientDashboard } from "@/components/portal/ClientDashboard";
import { AdminDashboard } from "@/components/admin/AdminDashboard";

export default function Portal() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!getToken()) { navigate("/sign-in"); return; }
    api.get("/auth/me")
      .then(({ data }) => setUser(data))
      .catch(() => navigate("/sign-in"))
      .finally(() => setLoading(false));
  }, [navigate]);

  if (loading || !user) {
    return <div className="flex min-h-screen items-center justify-center bg-background text-muted-foreground">…</div>;
  }
  return user.role === "admin" ? <AdminDashboard user={user} /> : <ClientDashboard user={user} />;
}
